import { ColorBadge } from './ColorBadge';

export type ColorPickSwatchesProps = {
    value: string | null;
    colors: string[];
    disabled?: boolean;
    onChange?: (color: string) => void;
};

export const ColorPickSwatches = (props: ColorPickSwatchesProps) => {
    const { disabled, value, colors, onChange } = props;

    return (
        <>
            {colors.map((color, i) => (
                <ColorBadge
                    key={i.toString()}
                    disabled={disabled}
                    color={color}
                    selected={color === value}
                    round
                    onClick={() => onChange?.(color)}
                />
            ))}
        </>
    );
};
